import React from 'react';
import PropTypes from 'prop-types';
import ProviderClaimProfileForm from './components/ProviderClaimProfileForm';
import { useHistory } from 'react-router-dom';
import AuthFormPage from './components/AuthFormPage';
import { ProviderAPI } from '../../api';

const ProviderClaimProfilePage = ({match}) => {
  const history = useHistory();
  const uuid = match.params.uuid;
  const [provider, setProvider] = React.useState(null);

  const signup = (email) => {
    history.push('/signup/confirm', {email});
  };

  // Get the provider profile data
  const fetchProfile = async () => {
    try {
      const { payload } = await ProviderAPI.getProfile(uuid);
      setProvider(payload);
      if (payload && payload.active === false) {
        history.replace('/404-page-not-found');
      }
    } catch (err) {
      if (err.status === 404) {
        history.replace('/404-page-not-found');
      }
      console.error(err); // eslint-disable-line no-console
    }
  };

  React.useEffect(() => {
    fetchProfile();
  }, []); // eslint-disable-line

  if (provider == null) {
    return null;
  }

  const title = `Claim Clickability Provider profile for ${provider.name}`;

  return (
    <AuthFormPage title="Clickability Claim Provider Profile">
      <ProviderClaimProfileForm
        onComplete={signup}
        title={title}
        loginLink="/providers/login"
        provider={provider}
      />
    </AuthFormPage>
  );
};

ProviderClaimProfilePage.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ProviderClaimProfilePage;
